import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import makeStyles from '@glass/web/modules/theme/makeStyles';

import Button from '@glass/shared/components/Button/Button';
import ResumeBuilderLink from '@glass/shared/components/Link/ResumeBuilderLink/ResumeBuilderLink';

const useStyles = makeStyles()((theme) => {
  const spacing = theme.spacing(1);
  return {
    button: {
      paddingTop: spacing,
      paddingBottom: spacing,
      backgroundColor: theme.palette.background.paper,
      '&:hover': {
        backgroundColor: theme.palette.background.default,
      },
    },
  };
});

function ExperienceButton({
  params: paramsProp,
  children,
  trackProps,
  onClick,
  fullWidth,
  persistQueryParams,
  shallow,
  prefetch,
}) {
  const { classes } = useStyles();

  const { query } = useRouter();

  const params = useMemo(
    () => ({
      ...(persistQueryParams ? query : null),
      ...paramsProp,
    }),
    [paramsProp, persistQueryParams, query],
  );

  return (
    <Button
      className={classes.button}
      color="inherit"
      component={ResumeBuilderLink}
      fullWidth={fullWidth}
      params={params}
      prefetch={prefetch}
      shallow={shallow}
      trackProps={trackProps}
      variant="outlined"
      onClick={onClick}
    >
      {children}
    </Button>
  );
}

ExperienceButton.defaultProps = {
  fullWidth: true,
};

ExperienceButton.propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
  onClick: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  params: PropTypes.object,
  persistQueryParams: PropTypes.bool,
  prefetch: PropTypes.bool,
  shallow: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  trackProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

export default ExperienceButton;
